import { render } from "./AddOrder.vue?vue&type=template&id=25d4191b&ts=true"
import script from "./AddOrder.vue?vue&type=script&lang=ts"
export * from "./AddOrder.vue?vue&type=script&lang=ts"

import "./AddOrder.vue?vue&type=style&index=0&id=25d4191b&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__